import React from 'react'
import Link from 'gatsby'

const AmericanDreamRequirements = (props) => {
  const { QualificationInfo, EnglishRequirements, FeesAndScholarship, imgFile, imgHeading } = props

  return (
    <div className="container-fluid online-journey-inner american-dream-admissions py-5" style={{backgroundColor: "#fff"}}>
      <div className="row">
        <div className="col-md-6">
          <div class="text-box wow fadeInLeft pl-0" data-wow-duration="1s" data-wow-delay=".2s">
            <h3 className='text-center text-md-center mb-4'>Admissions Requirements</h3>
            <ul className="mt-3 mt-md-5">
              <li>
                <h4>Academic qualifications</h4>
                {
                  QualificationInfo.map(para => {
                    return (
                      <span key={Math.random() * 10000}> {para} </span>
                    )
                  })
                }
                <span> *Requirements may vary as per the university admission criteria </span>
              </li>
              <li>
                <h4>english requirements</h4>
                {
                  EnglishRequirements.map(para => {
                    return (
                      <span key={Math.random() * 10000}> {para} </span>
                    )
                  })
                }
                <span> *Requirements may vary as per the university admission criteria </span>
              </li>
              <li>
                <h4>fees and scholarships</h4>
                {
                  FeesAndScholarship.map(para => {
                    return (
                      <span key={Math.random() * 10000}> {para} </span>
                    )
                  })
                }
              </li>
            </ul>
            <a
              href="/#"
              class="btn-default wow fadeInUp mb-3 mb-md-0 mx-auto mx-md-0"
              data-wow-duration="1s"
              data-wow-delay=".1s"
            >
              Speak To An Expert
            </a>
          </div>
        </div>
        <div className="col-md-6 order-first order-md-last">
          <div class="image-holder wow fadeInRight mr-md-0 h-auto" data-wow-duration="1s" data-wow-delay=".1s">
            <h3 className='text-center mb-4'>{imgHeading}</h3>
            <img src={imgFile} className="university-sample-image-img"/>
          </div>
        </div>
      </div> 
    </div>
  )
}

export default AmericanDreamRequirements
